import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Checkbox, 
	FormControlLabel ,
	makeStyles
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
	saveAudiogram,
	saveRecd,
	saveReug,
	saveSession
} from "src/api/patientApi";
import {
	convert2AudiogramData,
	convert2RecdData,
	convert2ReugData
} from "src/utils/adapter";

import { useHiDevice } from "src/context/HiDeviceContext";

export default function Save({
	currentDeviceType,
	setCurrentDeviceType
}) {
	const [startSave, setStartSave] = useState(false);
	const { t } = useTranslation();
	// console.log("Invoking SaveFittingInfoToDevice with:", currentDeviceType);
	const save = () => {
		setStartSave(true);
	};
	const useStyle = makeStyles(theme => {
		return {
			paper: {
				width: 1000,
				height: 600
			}
		};
	});
	
	const SaveContent = ({ currentDeviceType,onClose }) => {
		const classes = useStyle();
		const {
			acousticsChartDataLeft,
			acousticsChartDataRight,
			audiogramIds
		} = useSelector(state => state.patient);
	
		let data = convert2AudiogramData(
			audiogramIds[0],
			acousticsChartDataLeft[0],
			acousticsChartDataRight[0]
		);
		const recd = convert2RecdData(
			acousticsChartDataLeft[1],
			acousticsChartDataRight[1]
		);
		const reug = convert2ReugData(
			acousticsChartDataLeft[2],
			acousticsChartDataRight[2]
		);
	
		// 勾选状态
		const [saveSessionChecked, setSaveSessionChecked] = useState(false);
		const [saveToDeviceChecked, setSaveToDeviceChecked] = useState(false);
	
		// 保存任务
		const [tasks, setTasks] = useState([]);
		const [allTasksCompleted, setAllTasksCompleted] = useState(false);
		const { connection, hubProxy } = useHiDevice();
	
	
		// 当 SaveItem 完成时调用
		const handleTaskComplete = (taskIndex) => {
			// 标记任务为完成
			setTasks(prevTasks => {
				const newTasks = [...prevTasks];
				newTasks[taskIndex].done = true; // 给每个 task 增加 done 属性
				if (tasks.every(task => task.done)) {
					setAllTasksCompleted(true);
				}
				return newTasks;
			});
	
		};
	
		const saveToDevice = () => {
			return new Promise((resolve, reject) => {
			  if (!connection || !hubProxy) {
				reject(new Error(t("toolbar.saveDialog.deviceHubNotReady")));
				return;
			  }
	
			  const startConnection = () => {
				console.log("Starting SignalR connection...");
				connection.start()
				  .done(() => {
					invokeSave();
				  })
				  .fail(err => reject(err));
			  };
		  
			  const invokeSave = () => {
				hubProxy.invoke("SaveFittingInfoToDevice",currentDeviceType)
				  .done(result => {
					console.log("=== invoke 完成 ===");
					console.log("返回值:", result);
					// console.log("返回值类型:", typeof result);
					// console.log("SaveFittingToDevice result:", result);
					if (result && result.success) {
						resolve(result);
					} else {
						reject(new Error(result?.message || result?.error || t("toolbar.saveDialog.deviceFail")));
					}
				  })
				  .fail(err => reject(err));
			  };
		  
			  if (connection.state === 1) { // 已连接 connected
				invokeSave();
			  } else {
				console.log("Connection not established. Current state:", connection.state);
				startConnection();
			  }
			});
		  };
		// const saveToDevice = () => {
		// 	return new Promise((resolve, reject) => {
		// 	  if (!hubProxy) {
		// 		reject(new Error("Hub 未初始化"));
		// 		return;
		// 	  }
		//       console.log("Invoking SaveFittingInfoToDevice with:", currentDeviceType);
		// 	  hubProxy.invoke("SaveFittingInfoToDevice",currentDeviceType)
		// 		.done(result => {
		// 		  console.log("SaveFittingInfoToDevice result:", result);
		// 		  if (result && result.success) {
		// 			resolve(result);
		// 		  } else {
		// 			reject(new Error(result?.message || result?.error || "写入助听器失败!"));
		// 		  }
		// 		})
		// 		.fail(err => reject(err));
		// 	});
		//   };
	
		const handleConfirm = () => {
			let newTasks = [];
	
			if (saveSessionChecked) {
				newTasks.push({
				  msg: t("toolbar.saveDialog.savingAudiogram"),
				  successMsg: t("toolbar.saveDialog.audiogramSuccess"),
				  failMsg: t("toolbar.saveDialog.audiogramFail"),
				  fun: () => saveAudiogram(data)
				});
				newTasks.push({
				  msg: t("toolbar.saveDialog.savingSession"),
				  successMsg: t("toolbar.saveDialog.sessionSuccess"),
				  failMsg: t("toolbar.saveDialog.sessionFail"),
				  fun: () => saveSession()
				});
			  }
		  
			  if (saveToDeviceChecked) {
				newTasks.push({
				  msg: t("toolbar.saveDialog.savingToDevice"),
				  successMsg: t("toolbar.saveDialog.deviceSuccess"),
				  failMsg: t("toolbar.saveDialog.deviceFail"),
				  fun: () => saveToDevice()
				});
			  }
			setTasks(newTasks);
			setAllTasksCompleted(false);
		};
		return (
			<Dialog
				open={true}
				maxWidth="md"
				classes={{
					paper: classes.paper
				}}
			>
				<DialogTitle id="link-hi">{t("toolbar.saveDialog.title")}</DialogTitle>
				<DialogContent>
					<Box mb={2}>
						<FormControlLabel
							control={
								<Checkbox
									checked={saveSessionChecked}
									disabled={allTasksCompleted}
									onChange={(e) => setSaveSessionChecked(e.target.checked)}
									color="primary"
								/>
							}
							label={t("toolbar.saveDialog.saveSession")}
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={saveToDeviceChecked}
									disabled={allTasksCompleted}
									onChange={(e) => setSaveToDeviceChecked(e.target.checked)}
									color="primary"
								/>
							}
							label={t("toolbar.saveDialog.saveToDevice")}
						/>
					</Box>
					{/* 保存任务显示区 */}
					<Box
						minHeight={120} // 保证有固定高度，不会空白
						display="flex"
						flexDirection="column"
						justifyContent={tasks.length === 0 ? "center" : "flex-start"}
						alignItems={tasks.length === 0 ? "center" : "stretch"}
						border={1}
						borderColor="grey.300"
						borderRadius={4}
						p={2}
					>
						{tasks.length === 0 ? (
						<Alert severity="info">{t("toolbar.saveDialog.chooseTaskTip")}</Alert>
						) : (
						tasks.map((task, idx) => <SaveItem key={idx} {...task} onComplete={()=>handleTaskComplete(idx)} />)
						)}
					</Box>
				</DialogContent>
				<DialogActions>
				{!allTasksCompleted && (
					<Button color="primary" variant="contained" onClick={handleConfirm}>
					{t("toolbar.saveDialog.confirm")}
					</Button>
				)}
	
				<Button color="secondary" variant="contained" onClick={onClose}>
					{allTasksCompleted ? t("toolbar.saveDialog.close") : t("toolbar.saveDialog.cancel")}
				</Button>
				</DialogActions>
			</Dialog>
		);
	};
	
	const SaveItem = ({ msg, successMsg, failMsg, fun, onComplete }) => {
		const [saveStatus, setSaveStatus] = useState({ status: false, msg: "", severity: "info" });
	  
		useEffect(() => {
		  setSaveStatus({ status: true, msg, severity: "info" });
		  fun()
			.then(() => {
			  setSaveStatus({ status: false, msg: successMsg, severity: "success" });
			  if (onComplete) onComplete(); 
			})
			.catch(() => {
			  setSaveStatus({ status: false, msg: failMsg, severity: "error" });
			  if (onComplete) onComplete(); 
			});
		}, []);
	  
		return (
		  <Alert icon={saveStatus.status ? <CircularProgress size={10} /> : null} severity={saveStatus.severity}>
			{saveStatus.msg}
		  </Alert>
		);
	  };

	const handleClose = () => {
		setStartSave(false);
	};

	return (
		<>
			{/* <ButtonBase onClick={save}>
				<SaveIcon size="20" />
			</ButtonBase> */}
			<Button
				onClick={save}
				size="small"
				variant="contained"
				color="primary"
			>
				{t("toolbar.save")}
			</Button>
			{startSave && <SaveContent currentDeviceType = {currentDeviceType} onClose={handleClose} />}
		</>
	);
}


